import { gql } from "@apollo/client";

export const QUERY_PERFORMANCE_METRICS = gql`
  query getPerformanceMetricsData {
    getPerformanceMetricsData {
      MetricSpec
      MetricLaps
    }
  }
`;

export const SUBSCRIBE_NEW_PERFORMANCE_METRICS_UPDATE = gql`
  subscription newPerformanceMetricsUpdate {
    newPerformanceMetricsUpdate {
      MetricSpec
      MetricLaps
    }
  }
`;

export const SUBSCRIBE_NEW_PERFORMANCE_METRICS_APPEND = gql`
  subscription newPerformanceMetricsAppend {
    newPerformanceMetricsAppend {
      MetricSpec
      MetricLaps
    }
  }
`;

export const QUERY_AVAILABLE_PERFORMANCE_METRICS_SEASONS = gql`
  query getAvailablePerformanceMetricsSeasons {
    getAvailablePerformanceMetricsSeasons
  }
`;

export const QUERY_AVAILABLE_PERFORMANCE_METRICS_EVENTS = gql`
  query getAvailablePerformanceMetricsEvents($season: Int!) {
    getAvailablePerformanceMetricsEvents(season: $season)
  }
`;

export const QUERY_PERFORMANCE_METRICS_FOR_EVENT = gql`
  query getPerformanceMetricsForEvent($event: String!) {
    getPerformanceMetricsForEvent(event: $event) {
      MetricSpec
      MetricLaps
    }
  }
`;

export const MUTATE_SAVE_PERFORMANCE_METRICS_DATA = gql`
  mutation savePerformanceMetricsData($season: Int!, $event: String!) {
    savePerformanceMetricsData(season: $season, event: $event)
  }
`;
